import script from "./DataTableExtin.vue?vue&type=script&setup=true&lang=js"
export * from "./DataTableExtin.vue?vue&type=script&setup=true&lang=js"

import "./DataTableExtin.vue?vue&type=style&index=0&id=c7eef42a&lang=scss"

const __exports__ = script;

export default __exports__